<template>
  <v-container class="px-0 py-1">
    <v-form ref="carteirasForm">
      <v-row>
        <v-col class="py-0" cols="12" sm="12" :md="isDialog? '6': '11'">
          <label>Nome da carteira</label>
          <v-text-field
            v-model="formData.nome"
            dense
            outlined
            type="text"
            :rules="formRules.required"
          ></v-text-field>
        </v-col>
        <!-- PRESTADORES -->
        <v-col class="py-0" cols="12" sm="12" :md="isDialog? '6': '11'">
          <label>Prestadores</label>
          <v-autocomplete
            v-model="formData.prestadores_ids"
            :items="prestadores"
            item-value="id"
            item-text="prest_nome"
            placeholder="Digite para pesquisar"
            multiple
            chips
            outlined
            flat
            solo
            dense
            filled
            :search-input.sync="searchInput"
          >
            <template v-slot:prepend-item>
              <v-list-item ripple @click="toggleAllSelection('prestadores_ids', 'prestadores', 'id', 'isAllPrestadores')">
                <v-list-item-content>
                  <v-list-item-title>{{isAllPrestadores? 'NENHUM' : 'TODOS' }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
            <template v-slot:item="data" @click="toggleSelecao(data.item, 'prestadores_ids', 'id')">
               {{data.item.prest_nome}}
            </template>
            <template v-slot:selection="data">
              <v-chip v-if="data.index < 5" small label class="ma-1">{{
                data.item.prest_nome
              }}</v-chip>
              <span v-if="data.index == 5" class="ml-2 grey--text caption">
                (+{{
                  formData.prestadores_ids.length == 6
                    ? formData.prestadores_ids.length - 5 + " outro"
                    : formData.prestadores_ids.length - 5 + " outros"
                }})
              </span>
            </template>
          </v-autocomplete>
        </v-col>
        <!-- OPERADORAS -->
        <v-col class="py-0" cols="12" sm="12" :md="isDialog? '6': '11'">
          <label>Operadoras</label>
          <v-autocomplete
            v-model="formData.operadoras_ans_ids"
            :items="operadoras"
            item-value="id"
            item-text="oper_nome"
            placeholder="Digite para pesquisar"
            multiple
            chips
            outlined
            flat
            solo
            dense
            filled
           :search-input.sync="searchInput"
          >
            <template v-slot:prepend-item>
              <v-list-item ripple @click="toggleAllSelection('operadoras_ans_ids', 'operadoras', 'id', 'isAllOperadoras')">
                <v-list-item-content>
                  <v-list-item-title>{{isAllOperadoras? 'NENHUM' : 'TODOS' }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
            <template v-slot:item="data" @click="toggleSelecao(data.item, 'operadoras_ans_ids', 'id')">
               {{data.item.oper_nome}}
            </template>
            <template v-slot:selection="data">
              <v-chip v-if="data.index < 5" small label class="ma-1">{{
                data.item.oper_nome
              }}</v-chip>
              <span v-if="data.index == 5" class="ml-2 grey--text caption">
                (+{{
                  formData.operadoras_ans_ids.length == 6
                    ? formData.operadoras_ans_ids.length - 5 + " outro"
                    : formData.operadoras_ans_ids.length - 5 + " outros"
                }})
              </span>
            </template>
          </v-autocomplete>
        </v-col>
         <!-- <v-col class="py-0" cols="12" sm="12" :md="isDialog? '6': '11'">
          <label>Gestor responsavel</label>
          <v-select
            v-model="formData.gestor"
            :items="listResponsavel"
            item-value="Id"
            item-text="UserName"
            placeholder="Digite para pesquisar"
            outlined
            flat
            solo
            dense
            filled
          >
          </v-select>
        </v-col> -->
        <!-- RESPONSÁVEIS -->
        <v-col class="py-0" cols="12" sm="12" :md="isDialog? '6': '11'">
          <label>Analistas</label>
          <v-autocomplete
            v-model="formData.owners_ids"
            :items="listResponsavel"
             item-value="Id"
            item-text="UserName"
            placeholder="Digite para pesquisar"
            multiple
            chips
            outlined
            flat
            solo
            dense
            filled
            :search-input.sync="searchInput"
          >
            <template v-slot:prepend-item>
              <v-list-item ripple @click="toggleAllSelection('owners_ids', 'listResponsavel', 'Id', 'isAllResponsaveis')">
                <v-list-item-content>
                  <v-list-item-title>{{isAllResponsaveis? 'NENHUM' : 'TODOS' }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
            <template v-slot:item="data">
              <span v-html="data.item.UserName" ></span>
            </template>
            <template v-slot:selection="data">
              <v-chip v-if="data.index < 5" small label class="ma-1">{{
                data.item.UserName
              }}</v-chip>
              <span v-if="data.index == 5" class="ml-2 grey--text caption">
                (+{{
                  formData.owners_ids.length == 6
                    ? formData.owners_ids.length - 5 + " outro"
                    : formData.owners_ids.length - 5 + " outros"
                }})
              </span>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col class="text-left py-0 pb-2" cols="12" sm="6" md="5">
          <v-btn
            outlined
            max-width="100%"
            height="30px"
            small
            color="primary"
            depressed
            class="px-2"
            @click="reset()"
            >{{apenasVer? 'voltar' : 'cancelar'}}</v-btn
          >
        </v-col>
        <v-col class="text-right py-0 pb-2" cols="12" sm="6" :md="isDialog?'7':'6'" v-show="!apenasVer">
          <v-btn
            max-width="100%"
            height="30px"
            small
            color="primary"
            depressed
            class="px-2"
            @click="validate()"
            >salvar</v-btn
          >
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
const initialFormData = {
        nome: null,
        operadoras_ans_ids: [],
        prestadores_ids: [],
        owners_ids: [],
      }
export default {
  data() {
    return {
      formData: {...initialFormData },
      prestadores: [],
      searchInput: null
    };
  },
  watch:{
    itemSelecionado: {
      deep: true,
      handler(val) {
        if(val){
          this.formData =  {...val}
          this.formData.operadoras_ans_ids = this.formData.operadoras_ans_ids.length? this.formData.operadoras_ans_ids : [ ...this.operadoras ]
          this.formData.prestadores_ids = this.formData.prestadores_ids.length? this.formData.prestadores_ids : [ ...this.prestadores ]
          this.formData.owners_ids = this.formData.owners_ids.length? this.formData.owners_ids : [ ...this.listResponsavel ] 
          
        } else {
          this.reset()
        }
      }
    }
  },
  mounted() {
    this.prestadores = this.$store.getters[ "permissions/getPrestadoresByGeco" ]();
    let opts = {
      grupoEconomico: this.grupoEconomico,
      limitar: false,
      modulo_operadora: "faturamento"
    }
    this.getOperadoras(opts)
    this.getResponsaveis(opts)
  },
  computed: {
    ...mapState({
      operadoras: (state) => state.faturamento.listOperadora,
      formRules: (state) => state.formRules,
      listResponsavel: (state) => state.recebiveis.listResponsavel
    }),
    isAllResponsaveis() {
        return this.formData.owners_ids.length == this.listResponsavel.length
    },
    isAllOperadoras() {
        return this.formData.operadoras_ans_ids.length == this.operadoras.length
    },
    isAllPrestadores() {
        return this.formData.prestadores_ids.length == this.prestadores.length
    },
  },
  methods: {
    ...mapActions({
      getOperadoras: "permissions/getOperadoras",
      getResponsaveis: "recebiveis/getResponsaveis"
    }),
    // toggleSelecao(item, campoDoForm, valor) {
    //   alert(item)
    //   if(!item){
    //     return
    //   }
    //   let index = this.formData[campoDoForm].indexOf(item.Id)
    //   //  index > -1  está excluindo a operadora
    //   if (index > -1) {
    //     this.formData[campoDoForm].splice(index, 1)
    //   } else {
    //     //  index < 0  está adicionando a operadora
    //       this.formData[campoDoForm].push(item[valor])
    //   }
    //   alert(!this.formData.operadora_ans_id.length)
    //   this.disableResponsaveis = !this.formData.operadora_ans_id.length
    //   this.$nextTick()
    //   return
    // },
    toggleAllSelection(campoDoForm, lista, valor, todosSelecionados) {
      this.searchInput = null
      if(this[todosSelecionados]) {
          this.formData[campoDoForm] = []
        } else {
          this.formData[campoDoForm] =  Array.from(this[lista]).map(el=> el[valor])
        }
        if(campoDoForm=='operadora_ans_id'){
          this.formData.owners_ids = !this.formData.operadoras_ans_ids.length? [] : this.formData.owners_ids
        }
        this.$nextTick()
    },
    reset() {
      this.formData = {...initialFormData}
      this.acao(null, 'editItem')
      this.$refs.carteirasForm.reset()
      this.$refs.carteirasForm.resetValidation()
    },
    validate() {
      if (this.$refs.carteirasForm.validate()) {
        this.sendForm(this.formData);
      }
    },
  },
  props: {
    acao: Function,
    close: Function,
    grupoEconomico: Number,
    isDialog: { type: Boolean, default: false },
    itemSelecionado: Object,
    apenasVer: Boolean,
    sendForm: Function
  },
};
</script>

<style>
</style>